import React, { useEffect, useState, useRef, Fragment } from "react";

import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import logoHead from "./logo/udes.png";
import { Toast } from "primereact/toast";

export function VisitRequest() {
  const [formData, setFormData] = useState({
    visit_name: "",
    visit_phone: "",
    visit_email: "",
    visit_organization: "",
    visit_number: "",
    visit_purpose: "",
    visit_start_date: "",
    visit_end_date: "",
  });
  const toast = useRef(null);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/visitRequestSubmit`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    // Check the response status code.
    if (response.status === 200) {
      toast.current.show({
        severity: "success",
        summary: "succès",
        detail: "Demande envoyée",
      });

      document.getElementById("visitSubmitBtn").disabled = true;
      // Success!
    } else {
      // Error!
      alert("An error occurred while submitting the form data.");
    }
  };

  return (
    <>
      <header className=" m-0  text-white main-banner">
        <div className="head-banner-logo">
          <img src={logoHead} alt="logoHead" />
        </div>
        <div className="banner-text-1">
          <p>
            République Algérienne Démocratique et Populaire Ministère de
            l'Enseignement Supérieur et de la Recherche Scientifique Direction
            Générale de la Recherche Scientifique et du Développement
            Technologique
          </p>
        </div>
        <div className="banner-text-2">
          <span>EPST/Centre de Développement des Energies Renouvelables</span>
        </div>
      </header>
      <h1 className="text-3xl font-bold text-center mt-5">
        Planifier une visite
      </h1>
      <div className="mx-auto max-w-2xl space-y-6 mt-8 mb-5">
        <div className="space-y-2 text-center">
          <p className="text-gray-500 dark:text-gray-400">
            Remplissez le formulaire ci-dessous pour demander une visite.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 p-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
            <div className="space-y-2">
              <Label className="text-xs md:text-sm" htmlFor="name">
                Nom complet
              </Label>
              <Input
                className="text-xs md:text-sm"
                id="name"
                placeholder="Entrez votre nom complet"
                required
                value={formData.visit_name}
                onInput={(e) => {
                  setFormData({ ...formData, visit_name: e.target.value });
                }}
              />
            </div>
            <div className="space-y-2">
              <Label className="text-xs md:text-sm" htmlFor="contact">
                Informations de contact
              </Label>
              <div className="grid grid-cols-2 gap-2">
                <Input
                  className="text-xs md:text-sm"
                  id="phone"
                  placeholder="Téléphone"
                  required
                  type="tel"
                  value={formData.visit_phone}
                  onInput={(e) => {
                    setFormData({ ...formData, visit_phone: e.target.value });
                  }}
                />
                <Input
                  className="text-xs md:text-sm"
                  id="email"
                  placeholder="Email"
                  required
                  type="email"
                  value={formData.visit_email}
                  onInput={(e) => {
                    setFormData({ ...formData, visit_email: e.target.value });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <Label className="text-xs md:text-sm" htmlFor="organization">
              École/Entreprise
            </Label>
            <Input
              className="text-xs md:text-sm"
              id="organization"
              placeholder="Entrez votre école ou entreprise"
              required
              value={formData.visit_organization}
              onInput={(e) => {
                setFormData({
                  ...formData,
                  visit_organization: e.target.value,
                });
              }}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label className="text-xs md:text-sm" htmlFor="visitors">
                Nombre de visiteurs
              </Label>
              <Input
                className="text-xs md:text-sm"
                id="visitors"
                min="1"
                placeholder="1"
                required
                type="number"
                value={formData.visit_number}
                onInput={(e) => {
                  setFormData({ ...formData, visit_number: e.target.value });
                }}
              />
            </div>
            <div className="space-y-2">
              <Label className="text-xs md:text-sm" htmlFor="purpose">
                Objet de la visite
              </Label>
              <Textarea
                className="text-xs md:text-sm"
                id="purpose"
                placeholder="Décrivez l'objet de votre visite"
                required
                value={formData.visit_purpose}
                onInput={(e) => {
                  setFormData({ ...formData, visit_purpose: e.target.value });
                }}
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label className="text-xs md:text-sm" htmlFor="date">
              Date de visite souhaitée
            </Label>
            <div className="grid grid-cols-2 gap-2">
              <Input
                className="text-xs md:text-sm"
                id="start-date"
                required
                type="date"
                lang="fr-FR"
                inputmode="dd/mm/yyyy"
                value={formData.visit_start_date}
                onInput={(e) => {
                  setFormData({
                    ...formData,
                    visit_start_date: e.target.value,
                  });
                }}
              />
              <Input
                className="text-xs md:text-sm"
                id="end-date"
                required
                type="date"
                inputmode="dd/mm/yyyy"
                lang="fr-FR"
                value={formData.visit_end_date}
                onInput={(e) => {
                  setFormData({ ...formData, visit_end_date: e.target.value });
                }}
              />
            </div>
          </div>
          <Button
            className="text-xs md:text-sm w-full bg-blue-800"
            type="submit"
            id="visitSubmitBtn"
          >
            Soumettre la demande de visite
          </Button>
        </form>
        <Toast ref={toast} />
      </div>
    </>
  );
}
